/* =========================================================
   Dolls In Love — Galerieseite als Slider (Marcel 21.10.2026)
   Pfeile, Wischen, Tastatur; Umschalter auf die Übersicht (Raster).
   Klick auf ein Bild führt zur Produktseite.
   ========================================================= */
(function () {
  'use strict';
  const $  = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const spur = $('#galleryGrid'), slider = $('#gallerySlider');
  if (!spur) return;
  const tiles = $$('.tile', spur);
  const frei = () => !!(window.DIL_ALTER && window.DIL_ALTER.frei());

  const schritt = () => { const t = tiles[0]; if (!t) return 300; const g = parseFloat(getComputedStyle(spur).columnGap) || 20; return t.getBoundingClientRect().width + g; };
  const geh = r => spur.scrollBy({ left: r * schritt(), behavior: 'smooth' });
  $('#galleryPrev').addEventListener('click', () => geh(-1));
  $('#galleryNext').addEventListener('click', () => geh(1));
  document.addEventListener('keydown', e => {
    if (slider.classList.contains('is-raster') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    if (e.key === 'ArrowRight') geh(1); if (e.key === 'ArrowLeft') geh(-1);
  });

  const zaehler = $('#galleryCount');
  function zeige() {
    if (slider.classList.contains('is-raster')) { zaehler.textContent = tiles.length + ' Modelle'; return; }
    const i = Math.round(spur.scrollLeft / schritt());
    const sichtbar = Math.max(1, Math.round(spur.clientWidth / schritt()));
    zaehler.textContent = `${Math.min(tiles.length, i + 1)}–${Math.min(tiles.length, i + sichtbar)} von ${tiles.length} Modellen`;
    $('#galleryPrev').disabled = spur.scrollLeft < 8;
    $('#galleryNext').disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 8;
  }
  spur.addEventListener('scroll', () => requestAnimationFrame(zeige), { passive: true });
  window.addEventListener('resize', zeige);
  zeige();

  /* Handy: direkt die Übersicht aller Modelle, kein Slider (Marcel 21.10.2026) */
  const handy = window.matchMedia('(max-width: 860px)');
  function ansichtFuerGeraet() { slider.classList.toggle('is-raster', handy.matches); spur.scrollLeft = 0; zeige(); }
  ansichtFuerGeraet();
  if (handy.addEventListener) handy.addEventListener('change', ansichtFuerGeraet);

  const knopf = $('#galleryAnsicht');
  knopf.addEventListener('click', () => {
    const r = slider.classList.toggle('is-raster');
    knopf.querySelector('span').textContent = r ? 'Zurück zum Slider' : 'Alle Modelle als Übersicht';
    spur.scrollLeft = 0; zeige();
    if (!r) slider.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function entsperren() {
    $$('.tile.is-locked').forEach(t => t.classList.remove('is-locked'));
    $$('.tile__lock').forEach(t => t.remove());
    const b = $('#altersbalken'); if (b) b.hidden = true;
  }
  if (frei()) entsperren();
  if (window.DIL_ALTER) window.DIL_ALTER.beiFreigabe(entsperren);
  const gesperrteAnzahl = $$('.tile.is-locked', spur).length;
  const balken = $('#altersbalken');
  if (balken) {
    if (frei() || !gesperrteAnzahl) balken.hidden = true;
    else $('#altersbalkenText').textContent = gesperrteAnzahl + ' Aufnahmen sind aus Jugendschutzgründen unscharf.';
  }
})();
